import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Stack,
  Typography,
} from "@mui/material";

const months = ["Spring", "Summer", "Autumn", "Winter"];

const WeedingTable = ({ data }) => {
  //   let filteredPlants = data;
  //   if (searchTerm) {
  //     filteredPlants = data.filter((plant) => {
  //       return plant.name.toLowerCase().includes(searchTerm.toLowerCase());
  //     });
  //   }

  // For each month, get the plants that flower in that month
  let plantsByMonth = [];
  months.forEach((month) => {
    // e.g. month = spring

    let plantsInMonth = data.filter((plant) => {
      let flowerTimeArray = plant.flowerTime;
      let flowerTimeArrayLower = flowerTimeArray.map((month) => {
        return month.toLowerCase();
      });
      // if flowerTime is N/A, return in spring
      if (flowerTimeArrayLower.includes("n/a") && month === "Spring") {
        return true;
      }

      return flowerTimeArrayLower.includes(month.toLowerCase());
    });
    plantsByMonth.push(plantsInMonth);
  });

  console.log(plantsByMonth);

  return (
    <TableContainer
      component={Paper}
      style={{
        maxWidth: "40rem",
      }}
    >
      <Table>
        <TableHead>
          <TableRow
            style={{
              backgroundColor: "#f5f5f5",
            }}
          >
            <TableCell>Month</TableCell>
            <TableCell>Weeds To Look For</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {months.map((month, index) => (
            <TableRow key={month}>
              <TableCell>{month}</TableCell>
              <TableCell>
                <Stack>
                  {plantsByMonth[index].map((plant) => (
                    <Stack
                      key={plant.name}
                      direction={"row"}
                      spacing={2}
                      style={
                        {
                          //   display: "flex",
                          //   //   alignItems: "center",
                          //   flexDirection: "column",
                          //   //   // space between
                          //   justifyContent: "space-between",
                        }
                      }
                    >
                      <Avatar
                        alt={plant.name}
                        src={plant.image}
                        sx={{ width: 24, height: 24 }}
                      />
                      <Typography
                        variant="body1"
                        style={{
                          color: "black",
                        }}
                      >
                        {plant.name}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </TableCell>
              {/* <TableCell
                style={{
                  display: "flex",
                  //   alignItems: "center",
                  flexDirection: "column",
                  //   // space between
                  justifyContent: "space-between",
                }}
              >
                
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WeedingTable;
